'use strict';

class PasswordReminder {
  constructor($location, userService, I18N) {
    this.$location = $location;
    this.userService = userService;
    this.I18N = I18N;
  }

  $onInit() {
    this.alert = {};
    this.email = null;
    this.sent = false;
    this.expired = false;

    this.load();
  }

  load() {
    this.params = this.$location.search();
    this.usernameFromUrl = this.params.username;

    if (this.usernameFromUrl) {
      this.expired = true;
      this.email = this.usernameFromUrl;
    }
  }

  reminder() {
    this.userService.remindPassword(this.email)
      .then(() => {
        this.alert = {
          type: 'success',
          message: this.I18N.user.password
        };

        this.sent = true;
      });

    this.email = null;
  }
}

PasswordReminder.$inject = ['$location', 'userService', 'I18N'];

const passwordReminder = {
  controller: PasswordReminder,
  template: `
    <div class="row">
      <div class="large-7 columns">
        <h2 ng-hide="$ctrl.expired">Glemt passord</h2>
        <h2 ng-show="$ctrl.expired">Passordet ditt er utløpt, vennligst angi et nytt</h2>

        <form name="passwordForm" ng-submit="$ctrl.reminder()" ng-cloak novalidate>
          <alert data="$ctrl.alert" />

          <fieldset ng-hide="$ctrl.sent">
            <div>
              <label for="email">E-postadresse</label>
              <input type="email" id="email" name="email" autocomplete="email" ng-model="$ctrl.email" maxlength="64" placeholder="ola@nordmann.no" required autofocus>
              <span class="error" ng-show="passwordForm.email.$errorpass.required && passwordForm.email.$dirty">Vennligst oppgi en gyldig e-postadresse</span>
            </div>
            <button type="submit" ng-disabled="passwordForm.$invalid" class="button">Bytt passord</button>
          </fieldset>
        </form>
      </div>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('passwordReminder', passwordReminder)
  .config(($routeProvider) => {
    $routeProvider
      .when('/glemt-passord', {
        title: 'Glemt passord',
        template: '<password-reminder />',
        noSidebar: true,
        noNotification: true,
        secure: false
      });
  });
